import React, { memo } from 'react';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { keyMap } from '@locales/lokalise/keyMap';
import styles from './notificationBlock.styles.module.scss';

export const NotificationBlock = memo(
  ({ isNotificationDisplayed, onLinkClick }: { isNotificationDisplayed: boolean; onLinkClick: () => void }) => {
    if (!isNotificationDisplayed) {
      return null;
    }

    return (
      <div className={styles.notificationBlock}>
        <Trans i18nKey={keyMap.tradingAccountsOpenAccountError}>
          {'To enable this option, please, verify your '}
          <Link onClick={onLinkClick} to="/member/profile">
            Profile
          </Link>
        </Trans>
      </div>
    );
  },
);
